import { render, staticRenderFns } from "./ScreenTabFilteringControls.vue?vue&type=template&id=2cf454a1&scoped=true&"
import script from "./ScreenTabFilteringControls.vue?vue&type=script&lang=js&"
export * from "./ScreenTabFilteringControls.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTabFilteringControls.vue?vue&type=style&index=0&id=2cf454a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf454a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
